import { render, staticRenderFns } from "./Guatape.vue?vue&type=template&id=4e8cae1c&"
import script from "./Guatape.vue?vue&type=script&lang=js&"
export * from "./Guatape.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports